import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
// import axios from 'axios';

// components
import TopBar from '../components/navigaiton/TopBar';
import MainNav from '../components/navigaiton/MainNav';
import Sticky from '../components/navigaiton/Sticky';
// import NewsTicker from './singlets/NewsTicker';

export class Header extends Component  {
  state = { }

  componentDidMount() {
    // const getMobileMenu = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/758');

    // Promise.all([getMobileMenu]).then(res => {
    //   console.dir(res);
    //   this.setState({
    //     mobileMenu: res[0].data.items
    //   });
    // });
  }

  topOfContent() {
    let form = document.querySelector('#main');
    const y = form.offsetTop - 25;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    })
  }

  render() {
    // const { mobileMenu } = this.state;
    // console.dir(this.state);

    return (
      <>
        <button onClick={this.topOfContent} className="screen-reader-shortcut"> Skip to main content</button>
        {/* <NewsTicker /> */}

        <header>
          <TopBar />

          <section className="site-header">
            <div className="container">
              <div className="row">
                <div className="col-4 branding">
                  <a href="/"> <img src={process.env.PUBLIC_URL + '/global/images/logos/usa-logo.png'} alt="University of St. Augustine for Health Sciences" /> </a>
                </div>

                <div className="col-8 nav">
                  <MainNav />
                </div>
              </div>
            </div>
          </section>

          <Sticky />
        </header>
      </>
    );
  }
}

export default Header;